import {  useEffect } from 'react'
import styles from './Dashboard.module.css'
import { useAuthStore, useToolsStore } from '../../store/appStore'
import { useUsersStore } from '../../store/usersStore'
import StatsCards from './cards/StatsCards';
import RecentToolsCard from './cards/RecentToolsCard';
import ConnectionsCard from './cards/ConnectionsCard';
import QuickActionsCard from './cards/QuickActionsCard';
import { UserRole } from '../../enums/userRole'
import { hasMinRole } from '../../lib/permissions'
import { useNavigate } from 'react-router-dom'

export default function Dashboard() {
  const user = useAuthStore(state => state.user)
  const navigate = useNavigate();
  const { tools } = useToolsStore(state => state)
  const { users } = useUsersStore(state => state)


  useEffect(() => {
    const canView = hasMinRole(user?.role?.id, UserRole.ToolManager) || user?.role?.id === UserRole.PromptEditor;
    if (!user || !canView) {
      navigate('/toolslist');
    }
  }, [user])

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <h1>Dashboard</h1>
        <p>Manage your AI tools and connectors!</p>
      </div>
      <div className={styles.wrapper}>
        <div className={styles.grid}>
          <StatsCards tools={tools} users={users} user={user} />
          <div className={styles.cards}>
            <RecentToolsCard tools={tools} user={user} />
          </div>
        </div>
        <div className={styles.gridRight}>
          <ConnectionsCard
            user={user}
          />
          <QuickActionsCard />
        </div>
      </div>
    </div>
  )
}